import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { VendorDataSKPResponseType } from 'features/Enterprise/Vendor/services/vendorDataSKP'

interface InitialStateType {
  isLoading: boolean
  isNewData: boolean
  vendorSKPResponse: VendorDataSKPResponseType[`data`]
  vendorCompanyName: string
}

const initialState: InitialStateType = {
  isLoading: false,
  isNewData: false,
  vendorSKPResponse: {
    astro_pic_catman_name: '',
    astro_pic_catman_role: '',
    astro_pic_finance_collection_name: '',
    pic_email: '',
    pic_name: '',
    pic_role: '',
    pic_phone_number: '',
    billing_name: '',
    billing_address: '',
  },
  vendorCompanyName: ``,
}

export const sliceName = 'vendorSKPData'

export const vendorSKPDataSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setVendorSKPForm: (state, action: PayloadAction<VendorDataSKPResponseType[`data`]>) => {
      state.vendorSKPResponse = action.payload
    },
    setIsNewData: (state, action: PayloadAction<boolean>) => {
      state.isNewData = action.payload
    },
    setVendorName: (state, action: PayloadAction<string>) => {
      state.vendorCompanyName = action.payload
    },
    resetVendorSKPForm: (state) => {
      state.vendorSKPResponse = initialState.vendorSKPResponse
    },
  },
})

export const { setLoading, setVendorSKPForm, setIsNewData, setVendorName, resetVendorSKPForm } =
  vendorSKPDataSlice.actions

export default vendorSKPDataSlice.reducer
